// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"checkbox_fieldset__HAL1_","root":"checkbox_root__hYXvt","indicator":"checkbox_indicator__Y0JTv","label":"checkbox_label__30Yuz"};